/** @file makeRandom: a seeded mulberry32 generator, so command randomness is an input. */

/** A generator of numbers in [0, 1) that depends only on `seed`. */
export function makeRandom(seed: number): () => number {
  let s = seed;
  return () => {
    let t = (s += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
